import { render, staticRenderFns } from "./InstitutionAccountItem.vue?vue&type=template&id=6ee8e6b3&"
import script from "./InstitutionAccountItem.vue?vue&type=script&lang=js&"
export * from "./InstitutionAccountItem.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionAccountItem.vue?vue&type=style&index=0&id=6ee8e6b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports